import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Button,
  Tooltip,
  MenuItem,
  Dialog,
  DialogTitle,
  Stack,
  useMediaQuery,
  IconButton,
} from '@mui/material';
import {
  Logout,
  Menu as MenuIcon,
  NotificationsNone as NotificationsNoneIcon,
  Settings,
  ArrowBack,
} from '@mui/icons-material';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  logoutAction,
  updateTokenAction,
} from '../Onboarding/auth/action';
import { decodeToken } from '../../utils/settings';
import { deleteRegisterNotificationToken } from '../../screen/distributor/action/util_action';
import HumbeeLogo from './HumbeeLogo';
import CustomSelect from '../../v2/MUI_custom_component/Select/CustomSelect';
import ReusableMenu from '../MUI_custom_component/Menu';
import CustomButton from '../MUI_custom_component/Button/CustomButton';
import Entity from '../../v3/Common/Entity';
import { resetEntityState, fetchSuppliers, resetSuppliers } from '../../v3/Common/Entity/actions/reduxActions';
import { PersonRounded } from '../../components/icons';
import Avatar from '../MUI_custom_component/Avatar';
import { useBackrouteContext } from '../../contexts/BackrouteContext';



function Header({
  isHomePage = false,
  sidebarTitle = null,
  backroute = null,
  toggleDrawer = null,
  isPwa,
  showMenu = true,
  onBackClick = null,
  showProfileIcon = true,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:1200px)");
  const navigationTarget = backroute ? backroute : -1;

  const { customBackHandler } = useBackrouteContext();
  const { loginUser } = useSelector((state) => ({
    loginUser: state.loginReducer.loginUser,
  }));
  const userName = loginUser?.full_name || "Guest";
  const [loading, setLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [decodedData, setDecodedData] = useState({});
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [tokenData, setTokenData] = useState({});
  const [firmOnboarded, setFirmOnboarded] = useState(null);
  const [
    shouldShowSupplierNudgeAfterFirmChange,
    setShouldShowSupplierNudgeAfterFirmChange,
  ] = useState(false);
  const selected_firm = useSelector(
    (state) => state.dashboardReducer.selected_firm,
  );
  const openMenu = Boolean(anchorEl);
  const {
    selectedSupplierData,
    selectedSupplier: selectedManufacturer,
    selectedEntity: selectedCompanyEntity,
    suppliers,
  } = useSelector((state) => state.entityReducer);
  useEffect(() => {
    const getTokenData = async () => {
      const decoded = await decodeToken();
      setDecodedData(decoded);
      setSelectedCompany(decoded?.default_company_info?.company_id);
    };
    getTokenData();
  }, []);

  const handleCompanyChange = async (event) => {
    dispatch(resetSuppliers());
    setLoading(true);
    const { data, error, message } = await updateTokenAction({
      company_id: event.target.value,
    });
    setTimeout(() => setLoading(false), 500);
    if (!error) {
      setSelectedCompany(event.target.value);
      localStorage.setItem("token", data);
      dispatch({ type: "SELECTED_FIRM", payload: event.target.value });
      dispatch(resetEntityState());
      setShouldShowSupplierNudgeAfterFirmChange(true);
      setTimeout(() => {
        dispatch(fetchSuppliers());
      }, 100);
      navigate("/");
    } else {
      toast.error(message);
    }
  };
  const handleCloseDropdown = () => setAnchorEl(null);
  const handleLogout = async () => {
    const userToken = JSON.parse(localStorage.getItem("message_token"));
    await deleteRegisterNotificationToken(userToken);
    await logoutAction();
    localStorage.clear();
    dispatch({ type: "LOGOUT" });
    setOpenLogoutDialog(false);
    navigate("/");
  };

  const SimpleDialog = ({ open, onClose }) => (
    <Dialog onClose={onClose} open={open}>
      <Box sx={{ p: 3, px: 8, textAlign: "center" }}>
        <DialogTitle variant="h6">Confirm Logout</DialogTitle>
        <Typography sx={{ mb: 3 }}>
          Are you sure you want to log out?
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={onClose} color="error" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleLogout} variant="contained">
            Yes, Logout
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
  const menuItems = [
    {
      label: "My Account",
      icon: <Settings fontSize="small" />,
      onClick: () => {
        navigate("/my-account");
        handleCloseDropdown();
      },
      visible: !isPwa,
    },
    {
      label: "Logout",
      icon: <Logout fontSize="small" />,
      onClick: () => {
        setOpenLogoutDialog(true); // make sure this function is defined
        handleCloseDropdown();
      },
      visible: !isPwa,
    },
  ];
  const getTokenData = async () => {
    const decoded = await decodeToken();
    setDecodedData(decoded);
    setFirmOnboarded(decoded?.default_company_info);
    setSelectedCompany(decoded?.default_company_info?.company_id);
  };
  useEffect(() => {
    if (selectedCompany) {
      dispatch({ type: "SELECTED_FIRM", payload: selectedCompany });
    }
  }, [selectedCompany]);
  useEffect(() => {
    getTokenData();
  }, [loginUser]);

  useEffect(() => {
    if (!shouldShowSupplierNudgeAfterFirmChange || !selectedSupplierData) {
      return;
    }

    if (selectedSupplierData?.nudge) {
      toast.warning(selectedSupplierData.nudge);
    }

    setShouldShowSupplierNudgeAfterFirmChange(false);
  }, [shouldShowSupplierNudgeAfterFirmChange, selectedSupplierData]);

  const onSupplierChange = (supplierId) => {
    const selectedSupplier = (suppliers || []).find(
      (supplier) => String(supplier.id) === String(supplierId),
    );
    if (selectedSupplier?.nudge) {
      toast.warning(selectedSupplier.nudge);
      return;
    }
    navigate("/");
    fetchSuppliers();
  };

  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#fff",
        borderBottom: "1px solid #F2F2F2",
        px: 1,
        py: 1,
        // mb: 2,
        color: "black",
        zIndex: 1201,
        boxShadow: `
            1px 1px 4px 0px #FFFFFF99 inset,
            -1px -1px 1px 0px #8C8C8C66 inset,
            -1px -1px 1px 0px #FFFFFF40 inset,
            1px 1px 1px 0px #FFFFFF66 inset
        `,
        borderRadius: "16px",
      }}>
      <Toolbar
        sx={{
          px: { xs: "0px", md: "16px" },
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}>
        {isMobile ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {isHomePage ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => navigate(isPwa ? "/pwa-main-menu" : "/")}>
                <HumbeeLogo
                  width={isMobile ? "122" : "166"}
                  height={isMobile ? "26" : "40"}
                />
              </Box>
            ) : (
              <>
                <IconButton
                  onClick={() =>
                    onBackClick ? onBackClick() : navigate(navigationTarget)
                  }
                  sx={{ mr: { md: 1 } }}>
                  <ArrowBack />
                </IconButton>
                {sidebarTitle && (
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {sidebarTitle}
                  </Typography>
                )}
              </>
            )}
          </Box>
        ) : (
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => navigate("/")}>
            <HumbeeLogo
              width={isMobile ? "122" : "166"}
              height={isMobile ? "26" : "40"}
            />
          </Box>
        )}
        {!isMobile && loginUser && !isPwa && firmOnboarded && (
          <Box sx={{ ml: 4, display: "flex", gap: 2 }}>
            <Box>
              <CustomSelect
                size="small"
                value={selected_firm || selectedCompany}
                onChange={handleCompanyChange}
                label="Firm"
                disabled={decodedData?.all_companies_info?.length === 1}>
                {decodedData?.all_companies_info?.map((company) => (
                  <MenuItem key={company.company_id} value={company.company_id}>
                    {company.company_name}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Box>
            <Box>
              <Entity
                supplierLabel="Manufacturer"
                gridSizes={{
                  supplier: { xs: 12, sm: 12 },
                }}
                onSupplierChange={onSupplierChange}
                forceRefresh={false}
                showManufacturerSelect={true}
                showEntitySelect={false}
                autoFetch={false}
              />
            </Box>
          </Box>
        )}

        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isMobile && !isHomePage && showMenu && (
            <IconButton
              onClick={() => {
                if (toggleDrawer) {
                  toggleDrawer();
                } else {
                  setOpenDrawer(true);
                }
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}>
              <MenuIcon />
              <Typography variant="labelM" sx={{ color: "#8c8c8c" }}>
                Menu
              </Typography>
            </IconButton>
          )}
          {!isPwa && (
            <IconButton onClick={() => navigate("/distributor/notifications")}>
              <NotificationsNoneIcon sx={{ fontSize: "24px" }} />
            </IconButton>
          )}

          {!(isMobile && !showProfileIcon) && (
            <Tooltip title="My Account">
              <Box
                onClick={() =>
                  customBackHandler
                    ? customBackHandler()
                    : navigate("/my-account")
                }
                sx={{ p: 0, display: "flex", alignItems: "center", mr: "4px" }}>
                <Avatar
                  label={!isMobile && userName}
                  size={50}
                  bg="#F7F7F7"
                  src={
                    loginUser?.profile_image?.file_data
                      ? `data:image/png;base64,${loginUser?.profile_image?.file_data}`
                      : undefined
                  }
                  icon={
                    !loginUser?.profile_image?.file_data ? (
                      <PersonRounded
                        sx={{ color: "#8c8c8c", fontSize: "16px" }}
                      />
                    ) : undefined
                  }
                />
              </Box>
            </Tooltip>
          )}
          {(loginUser || !isPwa) && (
            <ReusableMenu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseDropdown}
              menuItems={menuItems.filter((item) => item.visible)}
              sx={{ mt: 2 }}
            />
          )}
          {!loginUser && !isPwa && (
            <CustomButton
              variant="filled"
              color="primary"
              label="Login"
              sx={{ ml: { xs: 1, md: 2 } }}
              size="small"
              onClick={() => navigate("/login")}
            />
          )}
        </Box>
      </Toolbar>
      <SimpleDialog
        open={openLogoutDialog}
        onClose={() => setOpenLogoutDialog(false)}
      />
    </AppBar>
  );
}

export default Header;
